import { useEffect, useState } from "react";
import { Button, Stack, Typography, useTheme } from "@mui/material";

import { Strings } from "@app/constants";
import { Form } from "./form";
import { OTPForm } from "./OTPForm";
import { selectMyProfileState } from "@app/modules/my-profile/selector";
import { useRequestState } from "@app/hooks";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "@app/modules/common";

const MobileInfo = ({
  setGetCarValue,
  setActiveStep,
  methods,
}: any) => {
  const [verification, setVerification] = useState(false);
  const theme = useTheme();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { data } = useRequestState({
    stateSelector: selectMyProfileState,
  });

  const handleClick = () => {
    if(isAuthenticated){
      setGetCarValue(true);
      setActiveStep(9);
    }
  };
  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {Strings.step.mobileInfo.letsConnect}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.grey[500], textAlign: "center" }}
          >
            {Strings.step.mobileInfo.enterYourNumberto}
          </Typography>

          {!verification && (
            <Form
              setVerification={setVerification}
              methods={methods}
              userInformation={data}
              isAuthenticated={isAuthenticated}
              setActiveStep={setActiveStep}
              setGetCarValue={setGetCarValue}
            />
          )}
          {verification && (
            <Stack
              width={{ xs: "90%", sm: "40%" }}
              maxWidth={400}
              alignItems={"start"}
              pt={1}
              gap={1}
            >
              <Typography textAlign={"center"}>
                {Strings.step.mobileInfo.enterOTP}
              </Typography>
              <OTPForm setGetCarValue={setGetCarValue}
      setActiveStep={setActiveStep}/>
            </Stack>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export { MobileInfo };
